module.exports = __webpack_public_path__ + "img/17300354.36e02031.png";